// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-smallOnWide-text-51ff310e"};